import { render, staticRenderFns } from "./MapEditWidget.vue?vue&type=template&id=46b35b43&"
import script from "./MapEditWidget.vue?vue&type=script&lang=ts&"
export * from "./MapEditWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports